import { render, staticRenderFns } from "./BoxPerformanceComparisonRadarAM.vue?vue&type=template&id=18b6f382&scoped=true&"
import script from "./BoxPerformanceComparisonRadarAM.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonRadarAM.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonRadarAM.vue?vue&type=style&index=0&id=18b6f382&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b6f382",
  null
  
)

export default component.exports
import {QCard,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable})
